<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.tcSalesStatus === 'D'
              ? 'warning'
              : row.tcSalesStatus === 'N'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_tcSalesStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditPage', {
                  pageType: 'detail',
                  params: { code: row.tcFabricSalesCode },
                  query: { tcFabricSalesNo: row.tcFabricSalesNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M') && row.tcSalesStatus === 'N'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditPage', {
                  pageType: 'edit',
                  params: { code: row.tcFabricSalesCode },
                  query: { tcFabricSalesNo: row.tcFabricSalesNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D') && row.tcSalesStatus === 'N'"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_export') || '导出'"
            placement="top"
            v-if="allow('E') && row.tcSalesStatus === 'Y'"
          >
            <i class="el-icon-download tool-btn" @click="exportData(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_audit') || '审核'"
            placement="top"
            v-if="allow('C') && row.tcSalesStatus === 'N'"
          >
            <i class="el-icon-circle-check tool-btn" @click="audit(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    del({ tcFabricSalesCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.tcFabricSalesDelApi({ tcFabricSalesCode }).then((res) => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || res.msg,
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    audit({ tcFabricSalesCode }) {
      this.$confirm(
        this.$l('INDEX.tips_question_audit') || '是否审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .tcFabricSalesReviewApi({ tcFabricSalesCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_audit_success') || '提交成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    async exportData({ tcFabricSalesCode }) {
      const params = { tcFabricSalesCode }
      this.loadingOpen()
      const checkRes = await this.$api
        .tcFabricSalesExportCheckApi(params)
        .catch(() => null)

      const { status, msg } = checkRes || {}
      if (status != 200) {
        this.loadingClose()
        this.$message.error(msg)
        return
      }

      const exportRes = await this.$api
        .SYS_EXPORT_TASK('factory-tc-fabricSales-contract', params)
        .catch(() => null)
      this.loadingClose()
      const { status: exportStatus } = exportRes || {}
      if (200 !== exportStatus) {
        this.$message.error(
          this.$l('INDEX.Description_Failed_to_add_export_task') ||
            '导出任务添加失败'
        )
        return
      }
      this.$message({
        message:
          this.$l('INDEX.added_to_the_download_center') ||
          '导出任务已经添加到下载中心，请稍后从下载中心下载文件',
        type: 'success',
      })
    },
  },
}
</script>
<style lang="scss"></style>
